import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { urls } from 'constants/urls.constant';

import { AuthService } from 'use-cases/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  canActivate(): boolean {
    if (!this.authService.isAuthenticated) {
      void this.router.navigate([urls.signIn]);

      return false;
    }

    if (!this.authService.canManageUsers) {
      void this.router.navigate([urls.home]);

      return false;
    }

    return true;
  }
}
